import { useMemo } from 'react';
import { useTeamListQuery } from './useTeamListQuery';

export interface WorkspaceOwner {
  userId: number;
  email: string;
  /** The name the team pages and the o5 notice show for this workspace (`team.list.workspaceName`). */
  workspaceName: string;
}

/**
 * The OWNER row from `team.list`, for the "ask the workspace owner" note every member surface
 * shows (design o, ruling 8). This is the same query, with the same stale time, as
 * `useMyTeamRole` — mounting the two together costs one request, not two, because they share the
 * `team.list` cache entry. Returns `null` while the query is loading, on an error, or for a
 * caller with no team yet.
 */
export function useWorkspaceOwner(): WorkspaceOwner | null {
  const { data } = useTeamListQuery();
  return useMemo(() => {
    const owner = data?.members.find((member) => member.role === 'OWNER');
    if (data === undefined || owner === undefined) {
      return null;
    }
    return { userId: owner.userId, email: owner.email, workspaceName: data.workspaceName };
  }, [data]);
}
